import { redirect } from 'react-router';

import { liftAiAuth } from '~/utils/api';
import { canAccess, DOCUMENT_REVIEW, getDefaultRouteForRole } from '~/utils/role';

/**
 * Route guard for the document-review portal.
 *
 * The portal is open to consultants (scoped server-side to their own customer
 * accounts) and to LiftAI staff (superusers). Everyone else is redirected to
 * their default route. This is real protection, not just nav-hiding: the
 * sidebar entry is consultant-only, but the route is otherwise reachable by URL.
 */
export const documentReviewLoader = async () => {
  const { requireUser } = liftAiAuth();
  const { isLiftaiAdmin, userRole } = await requireUser();

  if (!isLiftaiAdmin && !canAccess(userRole, DOCUMENT_REVIEW)) {
    throw redirect(getDefaultRouteForRole(userRole));
  }

  return null;
};

/**
 * Guard for the operator Tools console copy of the portal. Consultants have
 * their own home at /ai-extracted, so the /tools tree is LiftAI-staff only —
 * consultants who reach a /tools/document-review URL are redirected out.
 */
export const toolsDocumentReviewLoader = async () => {
  const { requireUser } = liftAiAuth();
  const { isLiftaiAdmin, userRole } = await requireUser();

  if (!isLiftaiAdmin) {
    throw redirect(getDefaultRouteForRole(userRole));
  }

  return null;
};
